import { render, staticRenderFns } from "./summations.vue?vue&type=template&id=ccf245d8"
import script from "./summations.vue?vue&type=script&lang=js"
export * from "./summations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports